module.exports = __webpack_public_path__ + "static/media/medalha_2.c3e5c434.svg";